import { ILineItemDetail } from "../../shared/models";
import { IRFQSupplierQuotation, IRFQTemplateDetail, RfpRemark } from "./buyer-rfq";

export interface ILeastSupplierValue {
    least_price: number;
    line_item_number: string;
    material_master_id: number;
    supplier_id: number;
    supplier_name: string;
    line_item_id:any;
}

export interface IRFQSupplierResponseAnalysis extends IRFQTemplateDetail {
    quotations:any;
    un_reg_vendor:any;
    line_item_id:any;
    rfq_template_id:any;
    id: number;
    template_name: string;
    rfq_date: string;
    rfq_time: string;
    envelope_type: string;
    rfq_type: string;
    status: "" | "ARCHIVED";
    created_by: string;
    created_by_email ?: string;
    created_date_time: Date | string;
    modified_by?: any;
    modified_date_time?: any;
    rfq_supplier_quotations: IRFQSupplierQuotation[];
    rfp_remark: RfpRemark;
    frieght_added?:boolean;
    prId : any;
    least_supplier_value_lineitem_wise : Array<ILeastSupplierValue>;
    frieghtCharge?:number;
}

export enum NegotiationTypeEnum {
    LINE_ITEMS = "LINE_ITEMS",
    VENDORS = "VENDORS"
}

export enum NegotiationStatusEnum {
    Negotiation_In_Progress = "Negotiation In-progress",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED"
}

export interface INegotiationInfo {
    negotiationType : NegotiationTypeEnum,
    supplierResponseAnalysis : Array<IRFQSupplierResponseAnalysis>
}

export interface INegotiationCreateRequest {
    prId: number | string,
    rfq_template_id: number,
    buyer_id: number | string,
    negotiation_data: Array<INegotiation>
}
export interface INegotiationUpdateRequest {
    supplier_id: number | string,
    negotiation_data: Array<INegotiation>;
}

export interface INegotiation {
    un_reg_vendor:any;
    negotiation_id:any;
    buyer_id:any;
    prId:any;
    rfq_template_id:any;
    supplier_id: any,
    user_email:any,
    line_item_number: number | string,
    final_price: number,
    buyer_counter_offer: number,
    buyer_remarks: string,
    supplier_remarks ?: string,
    negotiation_status ?: NegotiationStatusEnum,
    negotiation_count: number,
    packing_percent_or_amount?: any,
    packing_charge?: any,
    final_packing_charge?: any,
    freight_percent_or_amount?: any,
    final_freight_charge?: any,
    freight_charge?:any,
    original_price?:any,
    original_payment_terms?: any;
    final_payment_terms?: any;
    id: any, //negotiation id
    supplier_name ?: string
    remark ?: string
    original_freight_charge?:any
    total_price ?: any
    original_packing_charge?:any
    purchase_order_currency?:any
    item_desc?:any
    material_code?:any
    line_item ?: Array<ILineItemDetail> // Using this field only for showing info in supplier table, not for API call
}

export interface IRFQanalyseSupplierQuotation{
    total_cost:any;
    quotations:any;
    isRegisteredVendor:boolean;
    isSelected:boolean;
    supplier_id:any;
    line_item_status:any;
    rfq_template_id:any;
    name:any;
    line_item_number?:any;
    currency?:any;
    negotiation_count?:any;
    id?:any;
    quantity?:any,
    unit_price?:any;
    final_price?:any;
    final_freight_charge?:any;
    final_packing_charge?:any;
    packing_charge?:any;
    total_price?:any;
    original_freight_charge?:any;
    original_packing_charge?:any;
    original_price?:any;   
    freight_percent_or_amount?:any;
    packing_percent_or_amount?:any;
    original_payment_terms?:any;
    final_payment_terms?:any;
    difference_amount?:any;
    vendor_name?:any;
    user_name?:any;
    vendor_payment_terms?:any;
    purchase_order_currency?:any;
    rank?:any;
    template_name?:any;
    material_master_id?:any;
    employee_code:any;
}

